import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the FilterCostCenterView.
 * @extends JetView
 */
export default class FilterCostCenterView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The layout configuration for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Current screen size

        // Left section containing input fields
        const left = {
            id: 'a1',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a1',
                    cols: [
                        {
                            view: 'text', // Text input for ID
                            name: 'Id',
                            type: 'number',
                            minWidth: 200,
                            label: _("<span class='icon-drivers-license-o'></span>ID"),
                            labelPosition: 'top',
                            placeholder: _('ID'),
                        },
                        {
                            view: 'combo', // Dropdown for TypeCenter
                            name: 'TypeCenter',
                            id: 'TypeCenter',
                            minWidth: 200,
                            label: _('Tipo de Centro'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                        },
                        {
                            view: 'text', // Text input for Name
                            name: 'Name',
                            minWidth: 200,
                            label: "<span class='icon-user'></span>" + _('Nombre'),
                            labelPosition: 'top',
                            placeholder: _('Nombre'),
                        },
                        {
                            view: 'text', // Text input for Code
                            name: 'Code',
                            minWidth: 200,
                            label: _('Código'),
                            labelPosition: 'top',
                            placeholder: _('Código'),
                        },
                        {
                            view: 'richselect', // Rich select for IsActivate
                            name: 'IsActivate',
                            minWidth: 200,
                            label: "<span class='icon-state'></span>" + _('Estado'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: 'null', value: _('Todos') },
                                { id: 'A', value: _('Activado') },
                                { id: 'I', value: _('Inactivado') },
                            ],
                        },
                    ],
                },
            ],
        };

        // Center and right sections (currently empty)
        const center_left = {
            margin: 5,
            minWidth: 200,
            rows: [],
        };
        const center_right = {
            margin: 5,
            minWidth: 200,
            rows: [],
        };
        const right = {
            margin: 5,
            minWidth: 200,
            rows: [],
        };

        // Upper section containing the left section
        const upper_section = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left],
                },
            ],
        };

        // Buttons section with actions
        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        {
                            view: 'button', // Button to add a center
                            value: _('Añadir Centro'),
                            type: 'form',
                            width: screen == 'small' ? 0 : 0,
                            minWidth: 250,
                            hidden: !devConfig.getPermAction('accountingCostCenterAdd', 'Add'), // Permission check
                            css: 'prm-accountingCostCenterAdd',
                            click: () => {
                                this.app.callEvent('addCostCenter:button', [{}]); // Event call for adding cost center
                            },
                        },
                        {
                            view: 'button', // Button to clear inputs
                            value: _('Limpiar'),
                            width: screen == 'small' ? 0 : 0,
                            minWidth: 250,
                            click: () => {
                                this.getRoot().clear(); // Clear form inputs
                            },
                        },
                        {
                            view: 'button', // Button to consult/filter
                            value: _('Consultar'),
                            hotkey: 'enter',
                            type: 'form',
                            width: screen == 'small' ? 0 : 0,
                            minWidth: 250,
                            id: 'consultDesk',
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get form values
                                this.app.callEvent('costCenter:filter', [filterdata]); // Event call for filtering
                            },
                        },
                    ],
                },
            ],
        };

        // Accordion section for mobile and desktop views
        const accordion_section = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            view: 'button', // Button for mobile consult
                            value: _('Consultar'),
                            hotkey: 'enter',
                            type: 'form',
                            width: screen == 'small' ? 0 : 0,
                            minWidth: 250,
                            id: 'consultMobile',
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get form values
                                this.app.callEvent('costCenter:filter', [filterdata]); // Event call for filtering
                            },
                        },
                        {
                            header: _('Filtros'), // Header for filters section
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Include upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };

        // Return the complete form configuration
        return {
            view: 'form',
            id: 'myForm',
            type: 'clean',
            rows: [accordion_section],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     */
    init() {
        if (screen.width < 500) {
            $$('consultDesk').hide(); // Hide desktop consult button on small screens
        }
        if (screen.width >= 500) {
            $$('consultMobile').hide(); // Hide mobile consult button on larger screens
        }
        webix
            .ajax() // AJAX request to fetch types of center
            .headers({
                'Content-type': 'application/json', // Set content type
            })
            .post(
                devConfig.geturlApi() + 'Accounting/GetTypesCenterPositionSelect', // API endpoint
                '{"Type":0}', // Request payload
                {
                    error: function (text, data, XmlHttpRequest) {
                        webix.message(_('Error! ')); // Error handling
                    },
                    success: function (text, data, XmlHttpRequest) {
                        var resp = JSON.parse(text); // Parse response
                        $$('TypeCenter').define('options', resp.Data); // Define options for TypeCenter
                        $$('TypeCenter').refresh(); // Refresh TypeCenter dropdown
                    },
                },
            );
    }
}

// FILE DOCUMENTED
